module.exports = __webpack_public_path__ + "img/ico-reply-white.25a688e9.svg";